import './api-common'
import { TAddon, TDuration, TPlanSummary } from './cms-types'
import { AddonSlug, planOrder, PlanSlug } from './planSlugs'
import fetch from 'node-fetch'
import { Project } from './project'
import { sortBy } from 'lodash-es'

export const planSummaries: Omit<TPlanSummary, 'pricing'>[] = [
  {
    description: 'scanProDescription',
    fees: ['freePostageCredit'],
    name: 'virtualOfficeScanPro',
    shortName: 'scanPro',
    slug: PlanSlug.SCAN_PRO,
    summary: 'scanProSummary',
  },
  {
    description: 'scanLiteDescription',
    fees: ['workFromAnywhere'],
    name: 'virtualOfficeScanLite',
    recommended: true,
    shortName: 'scanLite',
    slug: PlanSlug.SCAN_LITE,
    summary: 'scanLiteSummary',
  },
  {
    description: 'phoneDescription',
    fees: [],
    name: 'virtualOfficePhone',
    shortName: 'phone',
    slug: PlanSlug.PHONE,
    summary: 'phoneSummary',
  },
]

export const addons: Omit<TAddon, 'pricing'>[] = [
  {
    description: 'virtualOfficePhoneDescription',
    duration: 'month',
    icon: 'phone',
    slug: AddonSlug.VIRTUAL_OFFICE_PHONE,
    title: 'virtualOfficePhone',
  },
  {
    description: 'directorsServiceAddressDescription',
    duration: 'month',
    icon: 'privacy',
    slug: AddonSlug.DIRECTORS_SERVICE_ADDRESS,
    title: 'directorsServiceAddress',
  },
]
export const offers: Omit<TAddon, 'pricing'>[] = [
  {
    claimText: 'claimOffer',
    description: 'tideBusinessBankingDescription',
    duration: null,
    isService: true,
    offer: 'cashback',
    offer_category: 'banking',
    serviceLink: 'https://www.tide.co/partners/hoxton-mix/',
    slug: AddonSlug.TIDE_BUSINESS_BANKING,
    title: 'tideBusinessBanking',
  },
  {
    claimText: 'crunchServiceCTA',
    description: 'crunchServiceDescription',
    duration: null,
    isReferral: true,
    isService: true,
    offer: 'crunchServiceOffer',
    offer_category: 'accounting',
    slug: AddonSlug.CRUNCH,
    title: 'crunchServiceTitle',
  },
]

let plansPromise: Promise<{
  addons: {
    id: string
    price_id: string
    period_unit: TDuration
    price: number
  }[]
  plans: {
    id: string
    price_id: string
    period_unit: TDuration
    price: number
  }[]
}>

const getPlansFromAPI = async () => {
  if (!plansPromise) {
    plansPromise = fetch(`${Project.api}checkout/products`).then((res) =>
      res.json(),
    )
  }
  const plansRes = await plansPromise
  return {
    ...plansRes,
    plans: plansRes.plans.concat([]),
  }
}

export const getPlans = async function (includeNonListed?: boolean) {
  const plansPriceData = await getPlansFromAPI()
  const matchingPlanSummaries = planSummaries.concat([]) as TPlanSummary[]
  plansPriceData.plans.forEach((pricingData) => {
    const matchingPlan = planSummaries.findIndex(
      (v) => v.slug === pricingData.id,
    )
    if (matchingPlan !== -1) {
      matchingPlanSummaries[matchingPlan].pricing = matchingPlanSummaries[
        matchingPlan
      ].pricing || {
        month_price: '',
        month_price_id: '',
        year_price: '',
        year_price_id: '',
      }
      matchingPlanSummaries[matchingPlan].pricing[
        `${pricingData.period_unit}_price`
      ] = pricingData.price
      matchingPlanSummaries[matchingPlan].pricing[
        `${pricingData.period_unit}_price_id`
      ] = pricingData.price_id
    }
  })
  return sortBy(
    matchingPlanSummaries.filter((v) => {
      return !!v.pricing && (!!includeNonListed || !v.hideFromList)
    }),
    (v) => {
      let index = planOrder.indexOf(v.slug)
      if (index === -1) {
        index = 99
      }
      return index
    },
  )
}

export const getAddons = async (allAddons: boolean) => {
  const plansPriceData = await getPlansFromAPI()
  let matchingAddons: TAddon[]
  if (allAddons) {
    matchingAddons = addons.reverse().concat(offers) as TAddon[]
  } else {
    matchingAddons = addons.concat([]) as TAddon[]
  }
  plansPriceData.addons.forEach((pricingData) => {
    const matchingPlan = addons.findIndex((v) => v.slug === pricingData.id)
    if (matchingPlan !== -1) {
      matchingAddons[matchingPlan].pricing = matchingAddons[matchingPlan]
        .pricing || {
        month_price: '',
        month_price_id: '',
        year_price: '',
        year_price_id: '',
      }
      matchingAddons[matchingPlan].pricing[`${pricingData.period_unit}_price`] =
        pricingData.price
      matchingAddons[matchingPlan].pricing[
        `${pricingData.period_unit}_price_id`
      ] = pricingData.price_id
    }
  })
  // show addons without pricing
  matchingAddons.forEach((addon, key) => {
    if (!addon.hasOwnProperty('pricing')) {
      matchingAddons[key].pricing = {
        month_price: 0,
        month_price_id: '',
        year_price: 0,
        year_price_id: '',
      }
    }
  })
  return matchingAddons.filter((v) => !!v.pricing)
}
